import { render, staticRenderFns } from "./PageDefaultDiscussionPoints.vue?vue&type=template&id=5173ab96&"
import script from "./PageDefaultDiscussionPoints.vue?vue&type=script&lang=js&"
export * from "./PageDefaultDiscussionPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports